export const DEFAULT_INSURANCE_ID = '0'
